import { format } from 'date-fns';

export const informal = (dateObj) => {
  return format(dateObj, 'MMM D, YYYY');
};

export const shortInformal = (dateObj) => {
  return format(dateObj, 'MM/DD/YY');
};

export const currentYear = (dateObj) => {
  return format(dateObj, 'YYYY');
};

export const monthAndYear = (dateObj) => {
  return format(dateObj, 'MMMM YYYY');
};

export const sortByDateAsc = (predicate) => {
  return (a,b) => {
    if(new Date(b[predicate]) >= new Date(a[predicate])) {
      return 1;
    }
    return -1;
  }
};



// WEBPACK FOOTER //
// ./src/utilities/date.js